var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66801 15.1537H8.11601C9.32313 15.1537 10.3039 14.1731 10.3039 12.9658V5.26176C10.3039 4.05464 9.32331 3.07383 8.11601 3.07383H2.66801C1.46089 3.07383 0.480078 4.05446 0.480078 5.26176V12.9658C0.480078 14.1729 1.46071 15.1537 2.66801 15.1537ZM1.88008 5.26162C1.88008 4.82494 2.23118 4.47369 2.66801 4.47369H8.11601C8.55269 4.47369 8.90394 4.82479 8.90394 5.26162V12.9656C8.90394 13.4023 8.55284 13.7536 8.11601 13.7536H2.66801C2.23133 13.7536 1.88008 13.4024 1.88008 12.9656V5.26162Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.944 12.0209H12.1808L12.1506 11.9898C12.4393 11.9005 12.644 11.6292 12.644 11.3209V4.25287C12.644 2.28958 11.0511 0.696875 9.08799 0.696875H4.28799C3.89673 0.696875 3.58799 1.00562 3.58799 1.39687C3.58799 1.78813 3.89673 2.09687 4.28799 2.09687H9.08799C10.2809 2.09687 11.244 3.0602 11.244 4.25291V11.3209C11.244 11.7122 11.5528 12.0209 11.944 12.0209Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyBlack);
export default __webpack_public_path__ + "static/media/copy_black.a508f564900c3bee9ff22e4f0c67f3c6.svg";
export { ForwardRef as ReactComponent };